
// open popup slider
var index;
class productMediaPopup {
  constructor() {
      this.overlay = null;
      this.modal = document.querySelector('#product-media-popup');
      this.enableZoomOnHover();

      // document.querySelector('#ModalClose-product-media-popup').addEventListener('click', () => {
      //   window.zoomMediaLoaded = false;
      //   this.modal.querySelector('[data-zoommediacontainer]').innerHTML = '';
      // });

      this.modal.querySelector('.modal').addEventListener('click', (e) => {
        const path = e.composedPath();
        const clickedImage = path.find(el => el instanceof Element && el.matches?.('swiper-slide img'));
        const clickedIframe = path.find(el => el instanceof Element && el.matches?.('iframe'));
        const clickedArrow = path.find(el => el instanceof Element && el.matches?.('.swiper-button-next, .swiper-button-prev'));
        if (!clickedImage && !clickedIframe && !clickedArrow) {
          this.closeModal();
        }
      });

  }

  closeModal() {
    document.querySelector("#product-media-popup .modal").classList.remove("open");
    document.body.classList.remove('scroll-fixed');
    SiteOverlay.prototype.hideOverlay();
    window.zoomMediaLoaded = false;
    // this.modal.querySelector('[data-zoomMediaContainer]').innerHTML = '';
  }

  enableZoomOnHover=()=>{
      const images = document.querySelectorAll('.product-images-wrapper .image-zoom');
      images.forEach(image => {
        
          image.onclick = (event) => {
            event.preventDefault();
              this.clicked_image = event.currentTarget;
              this.clicked_media_id = this.clicked_image.getAttribute('data-media-id');
              this.openZoomModal();
              if(this.clicked_media_id != null){
                setTimeout(() => {
                    const swiperInstance = this.modal.querySelector('swiper-container').swiper;
                    console.log(".product-modal-slider swiper-slide[data-mediaid='"+this.clicked_media_id+"']")
                    // Find the index matching the clicked media
                    let targetIndex = parseInt(document.querySelector(".product-modal-slider swiper-slide[data-mediaid='"+this.clicked_media_id+"']").getAttribute("data-index")) - 1;
                    swiperInstance.slideTo(targetIndex);
                }, 300);
              }
              // index = parseInt(this.clicked_image.getAttribute('data-index'));
              // window.currentVariantTitle = this.clicked_image.querySelector('img')?.getAttribute('data-variant-title')?.toLowerCase();
              // //if(!window.currentVariantTitle) return;
              // window.productTitle = this.clicked_image.querySelector('img')?.getAttribute('alt')?.toLowerCase();
              // if(window.zoomMediaLoaded == true){
              //     this.openZoomModal();
              // }else{
              //     this.buildProductMediaUI();
              // }
          };
      });
  }

  buildProductMediaUI=()=>{
    let productMedia = window.globalSpace.product.media;
    if(!productMedia) return;

    const variantTitle = window.currentVariantTitle;
    let allSlides = [];

    const filteredMedia = productMedia.filter(media => {
        if (media.media_type !== 'image') return false;
        const altText = (media.alt || window.productTitle).toLowerCase().trim();
        return altText === variantTitle || altText.split('||').some(v => v.trim() === variantTitle);
    });

    filteredMedia.forEach((media, i) => {
        allSlides.push({
            type: 'image',
            id: media.id,
            html: `<swiper-slide class="text-center" data-index="${allSlides.length}" data-media-id="${media.id}" role="treeitem">
                        <div class="align-items-center d-flex h-100 justify-content-center">
                          <img src="${media.src}" alt="${media.alt}" width="${media.width}" height="${media.height}">
                        </div>
                   </swiper-slide>`
        });
    });

    // Add custom videos
    const customVideoBlocks = document.querySelectorAll('.pdp-media-block[data-video-url]');
    customVideoBlocks.forEach((block, i) => {
        const videoUrl = block.getAttribute('data-video-url');
        const mediaId = block.getAttribute('data-media-id') || `custom-video-${i}`;
        allSlides.push({
            type: 'video',
            id: mediaId,
            html: `<swiper-slide class="text-center" data-index="${allSlides.length}" data-media-id="${mediaId}" role="treeitem" data-video-url="${videoUrl}" data-video-type="custom">
                        <div class="align-items-center d-flex h-100 justify-content-center position-relative">
                            <video src="${videoUrl}" width="100%" height="100%" autoplay loop muted playsinline></video>
                        </div>
                   </swiper-slide>`
        });
    });

    // Combine all HTML
    const finalHTML = allSlides.map(s => s.html).join('');
    let sliderHTML = `<swiper-container class="swiper-container light-arrow hide_arrow d-block w-100 h-100"
                        slides-per-view="1" speed="500" loop="false" threshold="20" space-between="30"
                        grab-cursor="true" navigation="true">
                        ${finalHTML}
                      </swiper-container>`;
    this.modal.querySelector('[data-zoomMediaContainer]').innerHTML = sliderHTML;

    this.openZoomModal(allSlides);

    window.zoomMediaLoaded = true;
  }

  openZoomModal = (allSlides) => {
    setTimeout(() => {
        const modal = document.querySelector("#product-media-popup .modal");

        document.body.classList.add('scroll-fixed');
        SiteOverlay.prototype.showOverlay();
        modal.classList.add("open");
    }, 320); // Delay in milliseconds
}
}

typeof productMediaPopup !== 'undefined' && new productMediaPopup();